import * as particles from "pixi-particles";
import { Graphics } from "pixi.js";
import particleManager from "slotworks/graphics/particles/particle-manager";
import Point from "slotworks/utils/geom/point";
import Layers from "slotworks/graphics/layers/layers";
import Timer from "slotworks/utils/timer";
import Contract from "slotworks/utils/contract";
import Components from "slotworks/components/components";
import gameState from "slotworks/model/game-state";
import RainbowStacksSpinRecord from "integration/revolver/schema/spin-record";

export default class ScatterEmitterComponent {

    private emittersLand: Map<number, particles.Emitter>;

    constructor() {
        this.emittersLand = new Map();
    }
    
    public init() {
        Components.matrix.landSignal.add((index: number) => {

            const record = gameState.getCurrentGame().getCurrentRecord() as RainbowStacksSpinRecord;
            
            let scatter = null;
            if(index == 1 || index == 3) {
                const reel = Components.matrix.getReels()[index - 1];
                scatter = reel.getSymbols().find(element => element.symbolId === "J0");
            } else if(index == 5 && record.triggersRespin) {
                const reel = Components.matrix.getReels()[index - 1];
                scatter = reel.getSymbols().find(element => element.symbolId === record.jackpotSymbol);
            }
            if(scatter) {
                const transform = scatter.getTransform();                   
                const layer = scatter.getLayer();                                                                                           
                const front = layer.localToLocal(Layers.Custom.get("Animations"), transform);              
                this.emit(index, front.x + transform.width/2, front.y);
            }    
        });
    }

    public emit(id:number, x: number, y: number) {   
        if(!this.emittersLand.has(id)) {        
            const emitterId = particleManager.add("scatterLand", new Point(x, y), Layers.Custom.get("Animations").container);
            const emitter = particleManager.get(emitterId);
            this.emittersLand.set(id, emitter);
            // if(id == 5) {
            //     emitter.maxParticles = 60;
            //     emitter.maxSpeed = 790;
            // }
        }
        const currentEmitter = this.emittersLand.get(id);
        setTimeout(() => {
            currentEmitter.updateSpawnPos(x - 8, y - 70);
            currentEmitter.emit = true;            
            setTimeout(() => { currentEmitter.emit = false;}, 500 );
        }, 200);
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/celebrate-win/scatter-emitter-component.ts